<script>
  import {apdate} from 'journalize';
  
  let date = window.UPDATED.replace(/-/g,'/');
  import { __ } from '../utils/i18n';
  
</script>


<span class="logo-container">

<h1 class="title" aria-level="1" aria-label="Shape your L.A.">
  <span class="logo-line"><span class="logo-letter" id="logo-s"  aria-hidden="true">S</span><span class="logo-letter" id="logo-h" aria-hidden="true">h</span><span class="logo-letter" id="logo-a" aria-hidden="true">a</span><span class="logo-letter" id="logo-p" aria-hidden="true">p</span><span class="logo-letter" id="logo-e" aria-hidden="true">e</span></span>
  <span class="logo-line"><span class="logo-letter" id="logo-y"  aria-hidden="true">Y</span><span class="logo-letter" id="logo-o" aria-hidden="true">o</span><span class="logo-letter" id="logo-u" aria-hidden="true">u</span><span class="logo-letter" id="logo-r" aria-hidden="true">r</span> <span class="logo-letter" id="logo-l" aria-hidden="true">L</span><span class="logo-letter" id="logo-dot-2" aria-hidden="true">.</span><span class="logo-letter" id="logo-a2" aria-hidden="true">A</span><span class="logo-letter" id="logo-dot" aria-hidden="true">.</span><span>
</h1>

  <div class="update-badge">
      <!-- <span class="pub-date">Updated {apdate(new Date(date))}</span> -->
    <span class="pub-date">{__("Updated July 1, 2026")}</span>
    <svg class="badge-background" aria-hidden="true" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    viewBox="0 0 89.2 87.4" transform="rotate(360)" style="enable-background:new 0 0 89.2 87.4;" xml:space="preserve">
      <style type="text/css">
        .st0{fill:#585BFC;}
      </style>
      <path class="st0" d="M81.7,67.3l-11.1-0.7c-3.5-0.2-6.5,2.4-6.8,5.9l-0.8,11.1c-0.1,1.2-1.4,1.7-2.3,1l-8.6-7.1
      c-2.7-2.2-6.7-1.9-8.9,0.8l-7.1,8.5c-0.7,0.9-2.2,0.6-2.5-0.6l-2.8-10.8c-0.9-3.4-4.3-5.4-7.7-4.6l-10.8,2.7
      c-1.1,0.3-2.1-0.8-1.7-1.9l4.1-10.3c1.3-3.3-0.3-6.9-3.5-8.3L0.9,49c-1.1-0.4-1.2-1.9-0.2-2.5l9.4-6c3-1.9,3.8-5.8,2-8.8l-5.9-9.4
      c-0.6-1,0.1-2.3,1.3-2.2l11.1,0.7c3.5,0.2,6.5-2.4,6.8-5.9l0.8-11.1c0.1-1.2,1.4-1.7,2.3-1L37,9.8c2.7,2.2,6.7,1.9,8.9-0.8l7.1-8.5
      c0.7-0.9,2.2-0.6,2.5,0.6l2.8,10.8c0.9,3.4,4.3,5.4,7.7,4.6l10.8-2.7c1.1-0.3,2.1,0.8,1.7,1.9L74.4,26c-1.3,3.3,0.3,6.9,3.5,8.3
      l10.3,4.2c1.1,0.4,1.2,1.9,0.2,2.5l-9.4,6c-3,1.9-3.8,5.8-2,8.8l5.9,9.4C83.7,66.1,82.9,67.4,81.7,67.3z"/>
    </svg>
  </div>
</span> 